import React from "react";
import { Link } from "react-router-dom";
import { Briefcase, Shield, Users } from "react-feather";
import { useClaims } from "../../auth/useClaims";
import { paths } from "../../../routes/paths";

const quickLinks = [
  {
    label: "Users",
    description: "Create accounts, assign roles, manage branch access.",
    icon: Users,
    path: paths.users,
    permission: "Admin.ManageUsers",
  },
  {
    label: "Roles",
    description: "Business-function permission bundles.",
    icon: Shield,
    path: paths.roles,
    permission: "Admin.ManageRoles",
  },
  {
    label: "Designations",
    description: "Job-title default permissions.",
    icon: Briefcase,
    path: paths.designations,
    permission: "Admin.ManageDesignations",
  },
];

const Dashboard = () => {
  const {
    fullName,
    username,
    roles,
    branches,
    isAllBranches,
    permissions,
    mustChangePassword,
    isLoading,
  } = useClaims();

  const visibleLinks = quickLinks.filter((link) =>
    permissions.includes(link.permission)
  );

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Welcome, {fullName || username}</h4>
              <h6>
                {roles?.join(", ") || "No roles assigned"} ·{" "}
                {isAllBranches ? "All branches" : branches?.join(", ") || "No branch access"}
              </h6>
            </div>
          </div>
        </div>

        {mustChangePassword && (
          <div className="alert alert-warning" role="alert">
            Your account has a temporary password. Please change it as soon
            as a change-password screen is available.
          </div>
        )}

        {isLoading ? (
          <p>Loading your access...</p>
        ) : (
          <div className="row">
            {visibleLinks.length === 0 && (
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <p className="mb-0">
                      You don&apos;t have access to any administration
                      screens yet.
                    </p>
                  </div>
                </div>
              </div>
            )}
            {visibleLinks.map(({ label, description, icon: Icon, path }) => (
              <div className="col-xl-4 col-sm-6 col-12" key={path}>
                <Link to={path} className="text-decoration-none">
                  <div className="card">
                    <div className="card-body d-flex align-items-start">
                      <span className="me-3">
                        <Icon size={28} />
                      </span>
                      <div>
                        <h5 className="mb-1">{label}</h5>
                        <p className="mb-0 text-muted">{description}</p>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
